import React from "react";
import styled from "styled-components";

// buttonType: 버튼의 개수 -> two: 취소, 확인 버튼 존재
interface ModalButtonProps {
  buttonType?: "one" | "two";
  confirmButtonText?: string;
  cancelButtonText?: string;
  handleConfirm: () => void;
  handleCancel?: () => void;
  isRedText?: boolean;

  buttonState?: "button" | "reset" | "submit" | undefined;
}

const ModalButton = ({
  buttonType = "one",
  confirmButtonText = "확인",
  cancelButtonText = "취소",
  handleConfirm,
  handleCancel,
  isRedText = false,
  buttonState,
}: ModalButtonProps) => {
  return (
    <ModalButtonContainer $isRed={isRedText}>
      {buttonType === "one" ? (
        <button
          type={buttonState}
          className="confirmButton"
          onClick={handleConfirm}
        >
          {confirmButtonText}
        </button>
      ) : (
        <div className="buttonContainer">
          <button className="cancelButton" onClick={handleCancel}>
            {cancelButtonText}
          </button>
          <button
            type={buttonState}
            className="confirmButton"
            onClick={handleConfirm}
          >
            {confirmButtonText}
          </button>
        </div>
      )}
    </ModalButtonContainer>
  );
};

export default ModalButton;

const ModalButtonContainer = styled.div<{ $isRed: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 5.1rem;

  button {
    all: unset;
    padding: 1.4rem 0;
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;
  }

  .buttonContainer {
    display: flex;
    width: 100%;

    button {
      width: 50%;
    }
  }

  .cancelButton {
    color: #40444a;
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 150%;
    border-right: 1px solid #e6eaee;
  }

  .confirmButton {
    color: ${({ $isRed }) => ($isRed ? "#F72A5C" : "#053692")};
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 150%;
  }
`;
